import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import y from "../common/base-provider.js";
import { newInAppMessageFromJson as it } from "../InAppMessage/in-app-message-factory.js";
import ue from "../models/braze-event.js";
import { InAppMessage } from "../InAppMessage/index.js";
import { isArray as p, isEqual as ii, validateValueIsFromEnum as F } from "../util/code-utils.js";
import { STORAGE_KEYS as o } from "../managers/storage-manager.js";
import ft from "../InAppMessage/models/templated-in-app-message.js";
import ut from "./models/trigger.js";
import V from "./models/trigger-events.js";
import r from "../../shared-lib/braze-shared-lib.js";

var ir = /*#__PURE__*/function (_y) {
  _inherits(ir, _y);

  var _super = _createSuper(ir);

  function ir(t, i, s, e, r) {
    var _this;

    _classCallCheck(this, ir);

    _this = _super.call(this), _this.Wh = t, _this.yt = i, _this.h = s, _this.si = e, _this.Gh = r, _this.Kh = [], _this.Yh = [], _this.Zh = null, _this.tg = {}, _this.ig = {}, _this.sg(), _this.eg();
    return _this;
  }

  _createClass(ir, [{
    key: "hg",
    value: function hg() {
      this.Zh = this.h.I(o.q.Ya) || this.Zh, this.tg = this.h.I(o.q.Da) || this.tg, this.ig = this.h.I(o.q.Ka) || this.ig;

      for (var t = 0; t < this.og.length; t++) {
        var i = this.og[t];
        null != this.ig[i.id] && i.Jh(this.ig[i.id]);
      }
    }
  }, {
    key: "sg",
    value: function sg() {
      this.ng = this.h.I(o.q.Ia) || 0;
      var t = this.h.I(o.q.ba) || [],
          i = [];

      for (var s = 0; s < t.length; s++) {
        i.push(ut.yn(t[s]));
      }

      this.og = i, this.hg();
    }
  }, {
    key: "eg",
    value: function eg() {
      var t = this,
          i = function i(_i, s, e, r, h) {
        return function () {
          t.lg(_i, s, e, r, h);
        };
      },
          s = {};

      for (var _t = 0; _t < this.og.length; _t++) {
        s[this.og[_t].id] = this.og[_t];
      }

      var e = !1;

      for (var _t2 = 0; _t2 < this.og.length; _t2++) {
        var _r = this.og[_t2];

        if (null != this.tg[_r.id]) {
          var _t3 = this.tg[_r.id],
              h = [];

          for (var _e = 0; _e < _t3.length; _e++) {
            var _o = _t3[_e],
                n = _r.Vh(_o.di);

            if (n > 0) {
              var _t4 = void 0,
                  _e2 = void 0;

              h.push(_o), null != _o.ag && (_t4 = _o.ag), null != _o.gg && ue.Ma(_o.gg) && (_e2 = ue.yn(_o.gg));
              var l = [];
              if (p(_o.fg)) for (var _t5 = 0; _t5 < _o.fg.length; _t5++) {
                var _i2 = s[_o.fg[_t5]];
                null != _i2 && l.push(_i2);
              }
              this.Yh.push(setTimeout(i(_r, _o.di, _t4, _e2, l), n));
            }
          }

          this.tg[_r.id].length > h.length && (this.tg[_r.id] = h, e = !0, 0 === this.tg[_r.id].length && delete this.tg[_r.id]);
        }
      }

      e && this.h.B(o.q.Da, this.tg);
    }
  }, {
    key: "cg",
    value: function cg() {
      var t = [];

      for (var i = 0; i < this.og.length; i++) {
        t.push(this.og[i].ss());
      }

      this.ng = new Date().valueOf(), this.h.B(o.q.ba, t), this.h.B(o.q.Ia, this.ng);
    }
  }, {
    key: "ug",
    value: function ug() {
      (this.h.I(o.q.Ia) || 0) > this.ng ? this.sg() : this.hg();
    }
  }, {
    key: "Rs",
    value: function Rs(t) {
      var i = !1;

      if (null != t && t.triggers) {
        this.hg();
        var s = {},
            e = {};
        this.og = [];

        for (var _r2 = 0; _r2 < t.triggers.length; _r2++) {
          var _h = ut.fromJson(t.triggers[_r2]);

          null != this.ig[_h.id] && (_h.Jh(this.ig[_h.id]), s[_h.id] = this.ig[_h.id]), null != this.tg[_h.id] && (e[_h.id] = this.tg[_h.id]);

          for (var _t6 = 0; _t6 < _h.Ph.length; _t6++) {
            if (_h.Ph[_t6].qa(V.ks, null)) {
              i = !0;
              break;
            }
          }

          null != _h && this.og.push(_h);
        }

        ii(this.ig, s) || (this.ig = s, this.h.B(o.q.Ka, this.ig)), ii(this.tg, e) || (this.tg = e, this.h.B(o.q.Da, this.tg)), this.cg(), i && (r.D.info("Trigger with test condition found, firing test."), this.je(V.ks)), this.je(V.OPEN);
        var h = this.Kh;
        this.Kh = [];

        for (var _t7 = 0; _t7 < h.length; _t7++) {
          this.je.apply(this, h[_t7]);
        }
      }
    }
  }, {
    key: "lg",
    value: function () {
      var _lg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t, i, s, e, h) {
        var _this2 = this;

        var o, n, _h2, l, a;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                o = function o(e) {
                  _this2.hg();

                  var h = new Date().valueOf();
                  if (!t.kh(i)) return !1 === navigator.onLine && t.type === ut.gi.mi && e.imageUrl ? (r.D.info("Not showing ".concat(t.type, " trigger action ").concat(t.id, " due to offline state.")), void _this2.Gh.qe(t.id, InAppMessage.Oe.Ki)) : void (t.Fh(h) && _this2.dg(t, h, s) ? (_this2.yt.St([e]), _this2.mg(t, h)) : r.D.info("Not displaying trigger ".concat(t.id, " because display time fell outside of the acceptable time window.")));
                  t.type === ut.gi.qh ? _this2.Gh.qe(t.id, InAppMessage.Oe.ui) : _this2.Gh.qe(t.id, InAppMessage.Oe.Yi);
                }, n = function n() {
                  _this2.hg();

                  var o = h.pop();
                  if (null != o) if (_this2.pg(o, i, s, e, h), o.kh(i)) {
                    var _t8 = "Server aborted in-app message display, but the timeout on fallback trigger ".concat(o.id, " has already elapsed.");

                    h.length > 0 && (_t8 += " Continuing to fall back."), r.D.info(_t8), _this2.Gh.qe(o.id, InAppMessage.Oe.Yi), n();
                  } else {
                    r.D.info("Server aborted in-app message display. Falling back to lower priority ".concat(o.type, " trigger action ").concat(t.id, "."));

                    var _n = 1e3 * o.bh - (new Date().valueOf() - i);

                    _n > 0 ? _this2.Yh.push(setTimeout(function () {
                      _this2.lg(o, i, s, e, h);
                    }, _n)) : _this2.lg(o, i, s, e, h);
                  }
                };
                _context.t0 = t.type;
                _context.next = _context.t0 === ut.gi.mi ? 4 : _context.t0 === ut.gi.qh ? 14 : 20;
                break;

              case 4:
                _h2 = it(t.data);

                if (!(null == _h2)) {
                  _context.next = 8;
                  break;
                }

                r.D.error("Could not parse trigger data for trigger ".concat(t.id, ", ignoring.")), this.Gh.qe(t.id, InAppMessage.Oe.ci);
                return _context.abrupt("break", 21);

              case 8:
                l = this.Gh.Ve(_h2);

                if (!l) {
                  _context.next = 12;
                  break;
                }

                r.D.error(l), n();
                return _context.abrupt("break", 21);

              case 12:
                o(_h2);
                return _context.abrupt("break", 21);

              case 14:
                a = ft.fromJson(t.data, o, n, i, t.vi);

                if (!(null == a)) {
                  _context.next = 18;
                  break;
                }

                r.D.error("Could not parse trigger data for trigger ".concat(t.id, ", ignoring.")), this.Gh.qe(t.id, InAppMessage.Oe.ci);
                return _context.abrupt("break", 21);

              case 18:
                this.Gh.Ze(a, s, e);
                return _context.abrupt("break", 21);

              case 20:
                r.D.error("Trigger ".concat(t.id, " was of unexpected type ").concat(t.type, ", ignoring.")), this.Gh.qe(t.id, InAppMessage.Oe.ci);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function lg(_x, _x2, _x3, _x4, _x5) {
        return _lg.apply(this, arguments);
      }

      return lg;
    }()
  }, {
    key: "je",
    value: function je(t, i, s) {
      var _this3 = this;

      if (!F(V, t, "Cannot fire trigger action.", "TriggerEvents")) return;
      if (this.si.Il()) return r.D.info("Trigger sync is currently in progress, awaiting sync completion before firing trigger event."), void this.Kh.push(arguments);
      this.ug();
      var e = new Date().valueOf(),
          h = e - this.Zh;
      var o = !0,
          n = !0;
      var l = [];

      for (var _s = 0; _s < this.og.length; _s++) {
        var _r3 = this.og[_s],
            _h3 = e + 1e3 * _r3.bh;

        if (_r3.Fh(_h3) && (null == _r3.startTime || _r3.startTime <= e) && (null == _r3.endTime || _r3.endTime >= e)) {
          var _s2 = !1;

          for (var _e3 = 0; _e3 < _r3.Ph.length; _e3++) {
            if (_r3.Ph[_e3].qa(t, i)) {
              _s2 = !0;
              break;
            }
          }

          _s2 && (o = !1, this.dg(_r3, _h3, t) && (n = !1, l.push(_r3)));
        }
      }

      if (o) return void r.D.info("Trigger event ".concat(t, " did not match any trigger conditions."));
      if (n) return void r.D.info("Ignoring ".concat(t, " trigger event because a trigger was displayed ").concat(h / 1e3, "s ago."));
      l.sort(function (t, i) {
        return t.priority - i.priority;
      });
      var a = l.pop();
      null != a && (r.D.info("Firing ".concat(a.type, " trigger action ").concat(a.id, " from trigger event ").concat(t, ".")), this.pg(a, e, t, s, l), 0 === a.bh ? this.lg(a, e, t, s, l) : this.Yh.push(setTimeout(function () {
        _this3.lg(a, e, t, s, l);
      }, 1e3 * a.bh)));
    }
  }, {
    key: "changeUser",
    value: function changeUser(t) {
      if (this.og = [], this.h.Xs(o.q.ba), !t) {
        this.Kh = [], this.Zh = null, this.ig = {}, this.tg = {};

        for (var _t9 = 0; _t9 < this.Yh.length; _t9++) {
          clearTimeout(this.Yh[_t9]);
        }

        this.Yh = [], this.h.Xs(o.q.Ya), this.h.Xs(o.q.Ka), this.h.Xs(o.q.Da);
      }
    }
  }, {
    key: "clearData",
    value: function clearData() {
      this.og = [], this.Zh = null, this.ig = {}, this.tg = {};

      for (var t = 0; t < this.Yh.length; t++) {
        clearTimeout(this.Yh[t]);
      }

      this.Yh = [];
    }
  }, {
    key: "dg",
    value: function dg(t, i, s) {
      if (null == this.Zh) return !0;
      if (s === V.ks) return r.D.info("Ignoring minimum interval between trigger because it is a test type."), !0;
      var e = t.xh;
      return null == e && (e = this.Wh), i - this.Zh >= 1e3 * e;
    }
  }, {
    key: "pg",
    value: function pg(t, i, s, e, r) {
      this.hg(), this.tg[t.id] = this.tg[t.id] || [];
      var h = {};
      var n;
      h.di = i, h.ag = s, null != e && (n = e.ss()), h.gg = n;
      var l = [];

      for (var _t10 = 0; _t10 < r.length; _t10++) {
        l.push(r[_t10].id);
      }

      h.fg = l, this.tg[t.id].push(h), this.h.B(o.q.Da, this.tg);
    }
  }, {
    key: "mg",
    value: function mg(t, i) {
      this.hg(), t.Jh(i), this.Zh = i, this.h.B(o.q.Ya, i), this.ig[t.id] = i, this.h.B(o.q.Ka, this.ig);
    }
  }]);

  return ir;
}(y);

export { ir as default };